import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { subscribeSong, stopSong, startSong } from "../lib/profileSong";

// App-wide audio guard (the mute button itself lives in the Navbar, on every skin):
// - Stops the Ancient Social song the moment we leave its home screen or switch skins.
// - Unmuting while on the Ancient Social home resumes the song.
export default function GlobalSongControl() {
  const location = useLocation();
  const { skin } = useTheme();
  const [muted, setMuted] = useState(false);
  useEffect(() => subscribeSong((st) => setMuted(st.muted)), []);

  const onSongHome = location.pathname === "/" && skin === "ancientsocial";
  useEffect(() => { if (!onSongHome) stopSong(); }, [onSongHome]);
  useEffect(() => { if (onSongHome && !muted) startSong(); }, [muted]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
